import React from 'react';
import { X, Check } from 'lucide-react';

export default function MentorUpgradeModal({ isOpen, onClose, currentPlan, newPlan, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4">
        <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <h3 className="text-xl font-bold">Upgrade Plan</h3>
            <button 
              onClick={onClose} 
              className="text-white/90 hover:text-white text-2xl leading-none"
            >
              ×
            </button>
          </div>
        </div>
        <div className="p-6">
          <p className="text-gray-600 mb-6">
            Upgrade from {currentPlan} to {newPlan}
          </p>
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={() => onConfirm({ billing: { confirmation: 'Upgrade successful!' } })}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Check className="w-4 h-4" />
              Confirm Upgrade
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}






